import type { GstModuleTypes } from "@/redux/gstModule/gstModuleTypes";

import type {
  GstrOneDataType,
  GstrOneFilingStatusDataType,
  GstrTwoADataType,
  GstrTwoBDataType,
  OutwardsDataType,
} from "@/commonTypes/gstTypes";

export const initialState: GstModuleTypes = {
  fetching: false,
  error: null,
  success: null,
  statusCode: null,
  message: null,
  totalOutwardsListCount: 0,
  totalInwardsListCount: 0,
  outwardsData: [] as OutwardsDataType[],
  inwardsData: [] as any,
  gstrOneData: {} as GstrOneDataType,
  totalCgstAmount: 0,
  totalIgstAmount: 0,
  totalInvoiceValue: 0,
  totalSgstAmount: 0,
  totalTaxableValue: 0,
  totalItcAmount: 0,
  lastSyncAt: null,
  gstrOneInvoiceList: [],
  gstrThreeBInvoiceList: [],
  getGstrOnehsnWiseList: [],
  gstrThreeBData: {},
  gstrTwoAReturnsData: [] as GstrTwoADataType[],
  gstrTwoBReturnsData: [] as GstrTwoBDataType[],
  gstFilingError: null,
  gstFilingSuccess: null,
  gstFilingStatusCode: null,
  gstFilingMessage: null,
  gstFilingFetching: false,
  gstNumberList: [],
  approvalSuccess: null,
  gstCommentData: [],
  gstCommentSuccess: null,
  gstOtpMessage: null,
  gstOtpVerifyMessage: null,
  gstOtpError: null,
  gstOtpVerifyError: null,
  gstOtpStatusCode: null,
  gstOtpVerifyStatusCode: null,
  gstOtpFetching: false,
  gstOtpVerifyFetching: false,
  gstOtpRequestFetching: false,
  gstOneFilingACKNumber: null,
  numberOfInvoices: 0,
  numberOfEInvoices: 0,
  numberOfUploadInvoices: 0,
  fetchFromGstPortal: 0,
  gstOneFilingStatus: {} as GstrOneFilingStatusDataType,
  gstOneFilingStatusSuccess: null,
  gstOneFilingStatusError: null,
  gstOneFilingStatusStatusCode: null,
  gstOneFilingStatusMessage: null,
  inwardGstr2a2bStatusResult: {},
  inwardGstr2a2bStatusResultFetching: false,
  gstr2a2bSyncStatusFetching: false,
  gstr2a2bSyncStatusJobResult: null,
  adminGstr1FilingReport: null,
  adminGstr1FilingReportFetching: false,
  adminGstr3bFilingReport: null,
  adminGstr3bFilingReportFetching: false,
  gstrThreeBFilingDetails: {},
  gstrThreeBFilingFetching: false,
  gstrThreeBFilingSuccess: null,
  gstrThreeBFilingError: null,
  gstrThreeBFilingStatusCode: null,
  gstrThreeBFilingMessage: null,
  gstrThreeBFilingACKNumber: null,
  gstrThreeBFilingSaveDataResult: {},

  gstrThreeBFilingStatusData: {},
  gstrThreeBFilingStatusSuccess: null,
  gstrThreeBFilingStatusError: null,
  gstrThreeBFilingStatusStatusCode: null,
  gstrThreeBFilingStatusMessage: null,
  gstr3BCashItcBalance: {},
  gstNoticesList: [],
  gstNoticesListFetching: false,
  gstNoticesListError: null,
  gstNoticesListStatusCode: null,
  gstNoticeDetails: null,
  gstNoticeDetailsFetching: false,
  gstNoticeDetailsError: null,
  gstNoticeDetailsStatusCode: null,
  gstNoticeDetailsMessage: null,
};
